import { useState, useCallback } from 'react';
import api from '../../../services/api';

export const useSponsors = () => {
  const [sponsors, setSponsors] = useState([]);
  const [monthlyTotal, setMonthlyTotal] = useState(0);
  const [loading, setLoading] = useState(false);

  const fetchSponsors = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const { data } = await api.get('/opticians/sponsors', {
        headers: { Authorization: `Bearer ${token}` }
      });

      console.log('Sponsors data:', data.sponsors);
      setSponsors(data.sponsors || []);
      setMonthlyTotal(data.monthlyTotal || 0);
    } catch (err) {
      console.error('Erreur sponsors:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  return { sponsors, monthlyTotal, loading, fetchSponsors };
};

